import Icon from '../components/Icon.vue'

Icon.register({
  'hat-wizard': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-480c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h480zM192 384l16 32h-144l111-249.7c11.1-25 29.8-45.7 53.5-59.1l187.6-107.2-56.3 168.9c-2.1 6.4-3.3 13.2-3.3 20.3 0 8.9 1.8 17.4 5.1 25.2l86.4 201.6h-208l16-32 64-32-64-32-32-64-32 64-64 32zM256 160l-32 16 32 16 16 32 16-32 32-16-32-16-16-32z'
      }
    ]
  }
})
